/**
 * Trilogy color
 */
export var TrilogyColor;
(function (TrilogyColor) {
    TrilogyColor["SUCCESS"] = "SUCCESS";
    TrilogyColor["INFO"] = "INFO";
    TrilogyColor["WARNING"] = "WARNING";
    /** @deprecated use ERROR instead */
    TrilogyColor["DANGER"] = "DANGER";
    TrilogyColor["ERROR"] = "ERROR";
    TrilogyColor["PRIMARY"] = "PRIMARY";
    TrilogyColor["SECONDARY"] = "SECONDARY";
    TrilogyColor["TERTIARY"] = "TERTIARY";
    TrilogyColor["WHITE"] = "WHITE";
    TrilogyColor["GREY"] = "GREY";
    TrilogyColor["GREY_DARK"] = "GREY_DARK";
    TrilogyColor["GREY_LIGHT"] = "GREY_LIGHT";
    TrilogyColor["GREY_LIGHTER"] = "GREY_LIGHTER";
    TrilogyColor["GREY_DISABLED"] = "GREY_DISABLED";
    // New accessible color palette
    TrilogyColor["PRIMARY100"] = "PRIMARY100";
    TrilogyColor["PRIMARY90"] = "PRIMARY90";
    TrilogyColor["PRIMARY80"] = "PRIMARY80";
    TrilogyColor["PRIMARY70"] = "PRIMARY70";
    TrilogyColor["PRIMARY60"] = "PRIMARY60";
    TrilogyColor["PRIMARY50"] = "PRIMARY50";
    TrilogyColor["PRIMARY40"] = "PRIMARY40";
    TrilogyColor["PRIMARY30"] = "PRIMARY30";
    TrilogyColor["PRIMARY20"] = "PRIMARY20";
    TrilogyColor["PRIMARY10"] = "PRIMARY10";
    TrilogyColor["SECONDARY100"] = "SECONDARY100";
    TrilogyColor["SECONDARY90"] = "SECONDARY90";
    TrilogyColor["SECONDARY80"] = "SECONDARY80";
    TrilogyColor["SECONDARY70"] = "SECONDARY70";
    TrilogyColor["SECONDARY60"] = "SECONDARY60";
    TrilogyColor["SECONDARY50"] = "SECONDARY50";
    TrilogyColor["SECONDARY40"] = "SECONDARY40";
    TrilogyColor["SECONDARY30"] = "SECONDARY30";
    TrilogyColor["SECONDARY20"] = "SECONDARY20";
    TrilogyColor["SECONDARY10"] = "SECONDARY10";
    TrilogyColor["TERTIARY100"] = "TERTIARY100";
    TrilogyColor["TERTIARY90"] = "TERTIARY90";
    TrilogyColor["TERTIARY80"] = "TERTIARY80";
    TrilogyColor["TERTIARY70"] = "TERTIARY70";
    TrilogyColor["TERTIARY60"] = "TERTIARY60";
    TrilogyColor["TERTIARY50"] = "TERTIARY50";
    TrilogyColor["TERTIARY40"] = "TERTIARY40";
    TrilogyColor["TERTIARY30"] = "TERTIARY30";
    TrilogyColor["TERTIARY20"] = "TERTIARY20";
    TrilogyColor["TERTIARY10"] = "TERTIARY10";
    TrilogyColor["GREY100"] = "GREY100";
    TrilogyColor["GREY90"] = "GREY90";
    TrilogyColor["GREY80"] = "GREY80";
    TrilogyColor["GREY70"] = "GREY70";
    TrilogyColor["GREY60"] = "GREY60";
    TrilogyColor["GREY50"] = "GREY50";
    TrilogyColor["GREY40"] = "GREY40";
    TrilogyColor["GREY30"] = "GREY30";
    TrilogyColor["GREY20"] = "GREY20";
    TrilogyColor["GREY10"] = "GREY10";
    TrilogyColor["WARNING100"] = "WARNING100";
    TrilogyColor["WARNING90"] = "WARNING90";
    TrilogyColor["WARNING80"] = "WARNING80";
    TrilogyColor["WARNING70"] = "WARNING70";
    TrilogyColor["WARNING60"] = "WARNING60";
    TrilogyColor["WARNING50"] = "WARNING50";
    TrilogyColor["WARNING40"] = "WARNING40";
    TrilogyColor["WARNING30"] = "WARNING30";
    TrilogyColor["WARNING20"] = "WARNING20";
    TrilogyColor["WARNING10"] = "WARNING10";
    TrilogyColor["SUCCESS100"] = "SUCCESS100";
    TrilogyColor["SUCCESS90"] = "SUCCESS90";
    TrilogyColor["SUCCESS80"] = "SUCCESS80";
    TrilogyColor["SUCCESS70"] = "SUCCESS70";
    TrilogyColor["SUCCESS60"] = "SUCCESS60";
    TrilogyColor["SUCCESS50"] = "SUCCESS50";
    TrilogyColor["SUCCESS40"] = "SUCCESS40";
    TrilogyColor["SUCCESS30"] = "SUCCESS30";
    TrilogyColor["SUCCESS20"] = "SUCCESS20";
    TrilogyColor["SUCCESS10"] = "SUCCESS10";
    TrilogyColor["ERROR100"] = "ERROR100";
    TrilogyColor["ERROR90"] = "ERROR90";
    TrilogyColor["ERROR80"] = "ERROR80";
    TrilogyColor["ERROR70"] = "ERROR70";
    TrilogyColor["ERROR60"] = "ERROR60";
    TrilogyColor["ERROR50"] = "ERROR50";
    TrilogyColor["ERROR40"] = "ERROR40";
    TrilogyColor["ERROR30"] = "ERROR30";
    TrilogyColor["ERROR20"] = "ERROR20";
    TrilogyColor["ERROR10"] = "ERROR10";
    TrilogyColor["PATTERN_DARK"] = "PATTERN_DARK";
    TrilogyColor["PATTERN_LIGHT"] = "PATTERN_LIGHT";
})(TrilogyColor || (TrilogyColor = {}));
/**
 * Returns color's className depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @returns {string} - Color value
 */
export const getColorClassName = (trilogyColor) => {
    switch (trilogyColor) {
        case 'SUCCESS':
            return 'success';
        case 'SUCCESS100':
            return 'success-100';
        case 'SUCCESS90':
            return 'success-90';
        case 'SUCCESS80':
            return 'success-80';
        case 'SUCCESS70':
            return 'success-70';
        case 'SUCCESS60':
            return 'success-60';
        case 'SUCCESS50':
            return 'success-50';
        case 'SUCCESS40':
            return 'success-40';
        case 'SUCCESS30':
            return 'success-30';
        case 'SUCCESS20':
            return 'success-20';
        case 'SUCCESS10':
            return 'success-10';
        case 'INFO':
            return 'info';
        case 'WARNING':
            return 'warning';
        case 'WARNING100':
            return 'warning-100';
        case 'WARNING90':
            return 'warning-90';
        case 'WARNING80':
            return 'warning-80';
        case 'WARNING70':
            return 'warning-70';
        case 'WARNING60':
            return 'warning-60';
        case 'WARNING50':
            return 'warning-50';
        case 'WARNING40':
            return 'warning-40';
        case 'WARNING30':
            return 'warning-30';
        case 'WARNING20':
            return 'warning-20';
        case 'WARNING10':
            return 'warning-10';
        /** @deprecated use ERROR instead */
        case 'DANGER':
            return 'danger';
        case 'ERROR':
            return 'error';
        case 'ERROR100':
            return 'error-100';
        case 'ERROR90':
            return 'error-90';
        case 'ERROR80':
            return 'error-80';
        case 'ERROR70':
            return 'error-70';
        case 'ERROR60':
            return 'error-60';
        case 'ERROR50':
            return 'error-50';
        case 'ERROR40':
            return 'error-40';
        case 'ERROR30':
            return 'error-30';
        case 'ERROR20':
            return 'error-20';
        case 'ERROR10':
            return 'error-10';
        case 'PRIMARY':
            return 'primary';
        case 'PRIMARY100':
            return 'primary-100';
        case 'PRIMARY90':
            return 'primary-90';
        case 'PRIMARY80':
            return 'primary-80';
        case 'PRIMARY70':
            return 'primary-70';
        case 'PRIMARY60':
            return 'primary-60';
        case 'PRIMARY50':
            return 'primary-50';
        case 'PRIMARY40':
            return 'primary-40';
        case 'PRIMARY30':
            return 'primary-30';
        case 'PRIMARY20':
            return 'primary-20';
        case 'PRIMARY10':
            return 'primary-10';
        case 'SECONDARY':
            return 'secondary';
        case 'SECONDARY100':
            return 'secondary-100';
        case 'SECONDARY90':
            return 'secondary-90';
        case 'SECONDARY80':
            return 'secondary-80';
        case 'SECONDARY70':
            return 'secondary-70';
        case 'SECONDARY60':
            return 'secondary-60';
        case 'SECONDARY50':
            return 'secondary-50';
        case 'SECONDARY40':
            return 'secondary-40';
        case 'SECONDARY30':
            return 'secondary-30';
        case 'SECONDARY20':
            return 'secondary-20';
        case 'SECONDARY10':
            return 'secondary-10';
        case 'TERTIARY':
            return 'tertiary';
        case 'TERTIARY100':
            return 'tertiary-100';
        case 'TERTIARY90':
            return 'tertiary-90';
        case 'TERTIARY80':
            return 'tertiary-80';
        case 'TERTIARY70':
            return 'tertiary-70';
        case 'TERTIARY60':
            return 'tertiary-60';
        case 'TERTIARY50':
            return 'tertiary-50';
        case 'TERTIARY40':
            return 'tertiary-40';
        case 'TERTIARY30':
            return 'tertiary-30';
        case 'TERTIARY20':
            return 'tertiary-20';
        case 'TERTIARY10':
            return 'tertiary-10';
        case 'WHITE':
            return 'white';
        case 'GREY':
            return 'grey';
        case 'GREY100':
            return 'grey-100';
        case 'GREY90':
            return 'grey-90';
        case 'GREY80':
            return 'grey-80';
        case 'GREY70':
            return 'grey-70';
        case 'GREY60':
            return 'grey-60';
        case 'GREY50':
            return 'grey-50';
        case 'GREY40':
            return 'grey-40';
        case 'GREY30':
            return 'grey-30';
        case 'GREY20':
            return 'grey-20';
        case 'GREY10':
            return 'grey-10';
        case 'GREY_DARK':
            return 'grey-dark';
        case 'GREY_LIGHT':
            return 'grey-light';
        case 'GREY_LIGHTER':
            return 'grey-lighter';
        case 'GREY_DISABLED':
            return 'grey-disabled';
        case 'PATTERN_DARK':
            return 'pattern-dark';
        case 'PATTERN_LIGHT':
            return 'pattern-light';
        case 'REFURB':
            return 'refurb';
        default:
            return 'tertiary';
    }
};
/**
 * Returns color's style depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @returns {string} - Color style value
 */
export const getColorStyle = (trilogyColor) => {
    switch (trilogyColor) {
        case 'SUCCESS':
            return '#007B52';
        case 'INFO':
            return '#0C7B91';
        case 'WARNING':
            return '#FFBB33';
        case 'DANGER':
            return '#D42D02';
        case 'ERROR':
            return '#D42D02';
        case 'PRIMARY':
            return '#CC4E0A';
        case 'SECONDARY':
            return '#0C7B91';
        case 'TERTIARY':
            return '#25465F';
        case 'WHITE':
            return '#fff';
        case 'GREY':
            return '#707070';
        case 'GREY_DARK':
            return '#646464';
        case 'GREY_LIGHT':
            return '#E9E9E9';
        /** @deprecated */
        case 'GREY_LIGHTER':
            return '#F4F4F4';
        case 'GREY_DISABLED':
            return '#D1D1D1';
        case 'PRIMARY100':
            return '#5B2204';
        case 'PRIMARY90':
            return '#813106';
        case 'PRIMARY80':
            return '#9E3C07';
        case 'PRIMARY70':
            return '#B64508';
        case 'PRIMARY60':
            return '#CC4E0A';
        case 'PRIMARY50':
            return '#D78572';
        case 'PRIMARY40':
            return '#E1ACA1';
        case 'PRIMARY30':
            return '#EBCBC5';
        case 'PRIMARY20':
            return '#F5E6E4';
        case 'PRIMARY10':
            return '#FAF3F1';
        case 'SECONDARY100':
            return '#053740';
        case 'SECONDARY90':
            return '#074D5B';
        case 'SECONDARY80':
            return '#095F70';
        case 'SECONDARY70':
            return '#0A6E81';
        case 'SECONDARY60':
            return '#0C7B91';
        case 'SECONDARY50':
            return '#729EAC';
        case 'SECONDARY40':
            return '#A1BBC4';
        case 'SECONDARY30':
            return '#C5D4D9';
        case 'SECONDARY20':
            return '#E4EAED';
        case 'SECONDARY10':
            return '#F1F5F6';
        case 'TERTIARY100':
            return '#101F2A';
        case 'TERTIARY90':
            return '#172C3C';
        case 'TERTIARY80':
            return '#1C3649';
        case 'TERTIARY70':
            return '#213E54';
        case 'TERTIARY60':
            return '#25465F';
        case 'TERTIARY50':
            return '#76828E';
        case 'TERTIARY40':
            return '#A3AAB1';
        case 'TERTIARY30':
            return '#C6CACE';
        case 'TERTIARY20':
            return '#E4E6E8';
        case 'TERTIARY10':
            return '#F2F2F3';
        case 'GREY100':
            return '#323232';
        case 'GREY90':
            return '#464646';
        case 'GREY80':
            return '#565656';
        case 'GREY70':
            return '#646464';
        case 'GREY60':
            return '#707070';
        case 'GREY50':
            return '#979797';
        case 'GREY40':
            return '#B7B7B7';
        case 'GREY30':
            return '#D1D1D1';
        case 'GREY20':
            return '#E9E9E9';
        case 'GREY10':
            return '#F4F4F4';
        case 'WARNING100':
            return '#725316';
        case 'WARNING90':
            return '#A17620';
        case 'WARNING80':
            return '#C59027';
        case 'WARNING70':
            return '#E4A72D';
        case 'WARNING60':
            return '#FFBB33';
        case 'WARNING50':
            return '#FFCA7A';
        case 'WARNING40':
            return '#FFD8A6';
        case 'WARNING30':
            return '#FFE6C8';
        case 'WARNING20':
            return '#FFF2E5';
        case 'WARNING10':
            return '#FFF9F2';
        case 'SUCCESS100':
            return '#003724';
        case 'SUCCESS90':
            return '#004D33';
        case 'SUCCESS80':
            return '#005F3F';
        case 'SUCCESS70':
            return '#006E49';
        case 'SUCCESS60':
            return '#007B52';
        case 'SUCCESS50':
            return '#729E87';
        case 'SUCCESS40':
            return '#A1BBAD';
        case 'SUCCESS30':
            return '#C5D4CC';
        case 'SUCCESS20':
            return '#E4EAE7';
        case 'SUCCESS10':
            return '#F1F5F3';
        case 'ERROR100':
            return '#5E1400';
        case 'ERROR90':
            return '#861C01';
        case 'ERROR80':
            return '#A42201';
        case 'ERROR70':
            return '#BD2801';
        case 'ERROR60':
            return '#D42D02';
        case 'ERROR50':
            return '#DD7872';
        case 'ERROR40':
            return '#E6A5A1';
        case 'ERROR30':
            return '#EEC7C5';
        case 'ERROR20':
            return '#F6E4E4';
        case 'ERROR10':
            return '#F6E4E4';
        case 'REFURB':
            return '#007B39';
        default:
            return '#25465f';
    }
};
//# sourceMappingURL=Color.js.map